import type { DashboardUser } from '../auth/auth-adapter'
import { getEnvironment } from '../../lib/environment'
import { ApiError, createApiClient } from '../../services/api/client'
import {
  issueReportPayloadSchema,
  issueReportResponseSchema,
  type IssueReportPayload,
  type IssueReportResponse,
} from './issue-report-contracts'

export type IssueReportRepository = {
  submit: (
    tenantId: string,
    payload: IssueReportPayload
  ) => Promise<IssueReportResponse>
}

type RepositoryOptions = {
  getUser: () => DashboardUser | null
  baseUrl?: string
  fetchImplementation?: typeof fetch
}

function endpoint(tenantId: string) {
  return `/dashboard/clinics/${encodeURIComponent(tenantId)}/issue-reports`
}

export function createIssueReportRepository({
  getUser,
  baseUrl = getEnvironment().userManagementBaseUrl,
  fetchImplementation,
}: RepositoryOptions): IssueReportRepository {
  const client = createApiClient({ baseUrl, getUser, fetchImplementation })

  return {
    submit(tenantId, payload) {
      return client.request(endpoint(tenantId), {
        method: 'POST',
        body: issueReportPayloadSchema.parse(payload),
        responseSchema: issueReportResponseSchema,
      })
    },
  }
}

export function isIssueReportRateLimitError(error: unknown) {
  return error instanceof ApiError && error.status === 429
}
